function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBookmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#feab00",
    d: "M 127.5,-0.5 C 140.5,-0.5 153.5,-0.5 166.5,-0.5C 176.628,10.7967 186.961,21.9634 197.5,33C 192.981,33.1753 188.647,33.6753 184.5,34.5C 172.833,34.5 161.167,34.5 149.5,34.5C 151.292,33.6909 153.292,33.1909 155.5,33C 145.232,22.5735 135.566,11.7402 126.5,0.5C 127.167,0.5 127.5,0.166667 127.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.968
    },
    fill: "#feb100",
    d: "M 166.5,-0.5 C 182.833,-0.5 199.167,-0.5 215.5,-0.5C 224.922,11.0938 234.922,22.2604 245.5,33C 248.365,33.1829 251.031,33.6829 253.5,34.5C 230.5,34.5 207.5,34.5 184.5,34.5C 188.647,33.6753 192.981,33.1753 197.5,33C 186.961,21.9634 176.628,10.7967 166.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#feb800",
    d: "M 215.5,-0.5 C 229.167,-0.5 242.833,-0.5 256.5,-0.5C 267.167,11.1667 277.833,22.8333 288.5,34.5C 276.833,34.5 265.167,34.5 253.5,34.5C 251.031,33.6829 248.365,33.1829 245.5,33C 234.922,22.2604 224.922,11.0938 215.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#febe00",
    d: "M 256.5,-0.5 C 270.5,-0.5 284.5,-0.5 298.5,-0.5C 308.628,10.7967 318.961,21.9634 329.5,33C 327.292,33.1909 325.292,33.6909 323.5,34.5C 311.833,34.5 300.167,34.5 288.5,34.5C 277.833,22.8333 267.167,11.1667 256.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.981
    },
    fill: "#ffc400",
    d: "M 298.5,-0.5 C 312.5,-0.5 326.5,-0.5 340.5,-0.5C 349.9,11.0739 359.9,22.2405 370.5,33C 365.981,33.1753 361.647,33.6753 357.5,34.5C 346.167,34.5 334.833,34.5 323.5,34.5C 325.292,33.6909 327.292,33.1909 329.5,33C 318.961,21.9634 308.628,10.7967 298.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#ffcb00",
    d: "M 340.5,-0.5 C 355.5,-0.5 370.5,-0.5 385.5,-0.5C 420.415,7.58243 441.248,29.2491 448,64.5C 448.5,79.1629 448.667,93.8295 448.5,108.5C 447.691,110.292 447.191,112.292 447,114.5C 436.333,103.167 425.667,91.8333 415,80.5C 414.809,82.7078 414.309,84.7078 413.5,86.5C 416.819,64.8932 409.153,48.7265 390.5,38C 387.226,36.7977 383.893,35.7977 380.5,35C 372.841,34.5003 365.174,34.3336 357.5,34.5C 361.647,33.6753 365.981,33.1753 370.5,33C 359.9,22.2405 349.9,11.0739 340.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fea500",
    d: "M 126.5,0.5 C 135.566,11.7402 145.232,22.5735 155.5,33C 153.292,33.1909 151.292,33.6909 149.5,34.5C 138.971,33.3679 128.971,35.0346 119.5,39.5C 113.573,32.069 107.073,25.069 100,18.5C 98.5787,16.5952 97.412,14.5952 96.5,12.5C 105.57,6.30283 115.57,2.30283 126.5,0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fe9f00",
    d: "M 96.5,12.5 C 97.412,14.5952 98.5787,16.5952 100,18.5C 107.073,25.069 113.573,32.069 119.5,39.5C 110.125,45.1962 103.791,53.1962 100.5,63.5C 92.5151,53.8819 83.8484,44.8819 74.5,36.5C 80.0753,26.9231 87.4087,18.9231 96.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#fe9800",
    d: "M 74.5,36.5 C 83.8484,44.8819 92.5151,53.8819 100.5,63.5C 99.5574,80.472 99.224,97.472 99.5,114.5C 88.199,101.864 76.5323,89.5311 64.5,77.5C 63.6192,62.692 66.9526,49.0253 74.5,36.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fe9200",
    d: "M 64.5,77.5 C 76.5323,89.5311 88.199,101.864 99.5,114.5C 99.5,128.833 99.5,143.167 99.5,157.5C 98.7611,157.631 98.0944,157.464 97.5,157C 86.6332,145.301 75.6332,133.801 64.5,122.5C 64.5,107.5 64.5,92.5 64.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#ffc400",
    d: "M 448.5,108.5 C 448.5,125.833 448.5,143.167 448.5,160.5C 437.2,149.032 426.034,137.365 415,125.5C 414.819,122.305 414.319,119.305 413.5,116.5C 413.5,106.5 413.5,96.5 413.5,86.5C 414.309,84.7078 414.809,82.7078 415,80.5C 425.667,91.8333 436.333,103.167 447,114.5C 447.191,112.292 447.691,110.292 448.5,108.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#febe00",
    d: "M 413.5,116.5 C 414.319,119.305 414.819,122.305 415,125.5C 426.034,137.365 437.2,149.032 448.5,160.5C 448.5,175.5 448.5,190.5 448.5,205.5C 436.833,193.5 425.167,181.5 413.5,169.5C 413.5,151.833 413.5,134.167 413.5,116.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.992
    },
    fill: "#fe8c00",
    d: "M 64.5,122.5 C 75.6332,133.801 86.6332,145.301 97.5,157C 98.0944,157.464 98.7611,157.631 99.5,157.5C 99.0335,172.496 98.7002,187.496 98.5,202.5C 86.7846,190.453 75.1179,178.453 63.5,166.5C 63.9931,151.838 64.3265,137.171 64.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fe8600",
    d: "M 63.5,166.5 C 75.1179,178.453 86.7846,190.453 98.5,202.5C 98.5,217.5 98.5,232.5 98.5,247.5C 87.1175,235.764 75.9508,223.764 65,211.5C 64.6174,212.056 64.1174,212.389 63.5,212.5C 63.5,197.167 63.5,181.833 63.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#fdb800",
    d: "M 413.5,169.5 C 425.167,181.5 436.833,193.5 448.5,205.5C 448.5,217.833 448.5,230.167 448.5,242.5C 447.686,244.631 447.186,246.964 447,249.5C 436.049,237.236 424.883,225.236 413.5,213.5C 413.5,198.833 413.5,184.167 413.5,169.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#fe8000",
    d: "M 98.5,247.5 C 98.5,264.167 98.5,280.833 98.5,297.5C 97.8826,297.611 97.3826,297.944 97,298.5C 85.9646,287.133 75.2979,275.466 65,263.5C 64.6174,264.056 64.1174,264.389 63.5,264.5C 63.5,247.167 63.5,229.833 63.5,212.5C 64.1174,212.389 64.6174,212.056 65,211.5C 75.9508,223.764 87.1175,235.764 98.5,247.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#fdb200",
    d: "M 413.5,213.5 C 424.883,225.236 436.049,237.236 447,249.5C 447.186,246.964 447.686,244.631 448.5,242.5C 448.5,260.167 448.5,277.833 448.5,295.5C 447.691,297.292 447.191,299.292 447,301.5C 435.6,289.604 424.433,277.604 413.5,265.5C 413.5,248.167 413.5,230.833 413.5,213.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.974
    },
    fill: "#fd7900",
    d: "M 98.5,297.5 C 98.5,313.167 98.5,328.833 98.5,344.5C 88.1647,334.33 78.3314,323.663 69,312.5C 67.549,310.536 65.7157,309.203 63.5,308.5C 63.5,293.833 63.5,279.167 63.5,264.5C 64.1174,264.389 64.6174,264.056 65,263.5C 75.2979,275.466 85.9646,287.133 97,298.5C 97.3826,297.944 97.8826,297.611 98.5,297.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fdab00",
    d: "M 413.5,265.5 C 424.433,277.604 435.6,289.604 447,301.5C 447.191,299.292 447.691,297.292 448.5,295.5C 448.5,315.167 448.5,334.833 448.5,354.5C 448.268,350.091 446.768,346.091 444,342.5C 433.967,331.635 423.8,320.968 413.5,310.5C 413.5,295.5 413.5,280.5 413.5,265.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#fd7300",
    d: "M 63.5,308.5 C 65.7157,309.203 67.549,310.536 69,312.5C 78.3314,323.663 88.1647,334.33 98.5,344.5C 98.5,359.167 98.5,373.833 98.5,388.5C 87.2002,377.032 76.0335,365.365 65,353.5C 64.6174,354.056 64.1174,354.389 63.5,354.5C 63.5,339.167 63.5,323.833 63.5,308.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.98
    },
    fill: "#fda500",
    d: "M 413.5,310.5 C 423.8,320.968 433.967,331.635 444,342.5C 446.768,346.091 448.268,350.091 448.5,354.5C 448.5,367.167 448.5,379.833 448.5,392.5C 437.567,380.396 426.4,368.396 415,356.5C 414.817,353.635 414.317,350.969 413.5,348.5C 413.5,335.833 413.5,323.167 413.5,310.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.977
    },
    fill: "#fd9f00",
    d: "M 413.5,348.5 C 414.317,350.969 414.817,353.635 415,356.5C 426.4,368.396 437.567,380.396 448.5,392.5C 448.5,404.833 448.5,417.167 448.5,429.5C 447.691,431.292 447.191,433.292 447,435.5C 435.966,423.635 424.8,411.968 413.5,400.5C 413.5,383.167 413.5,365.833 413.5,348.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.991
    },
    fill: "#fd6d00",
    d: "M 98.5,388.5 C 97.7025,402.819 97.3692,417.152 97.5,431.5C 94.2689,429.78 91.4356,427.447 89,424.5C 80.6667,415.5 72.3333,406.5 64,397.5C 63.6174,398.056 63.1174,398.389 62.5,398.5C 62.5479,383.825 62.8813,369.159 63.5,354.5C 64.1174,354.389 64.6174,354.056 65,353.5C 76.0335,365.365 87.2002,377.032 98.5,388.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#fe8700",
    d: "M 257.5,371.5 C 257.389,372.117 257.056,372.617 256.5,373C 281.467,400.302 306.8,427.302 332.5,454C 331.944,454.383 331.611,454.883 331.5,455.5C 306.486,439.992 281.153,424.992 255.5,410.5C 254.151,410.846 252.817,411.179 251.5,411.5C 243.16,403.16 235.16,394.493 227.5,385.5C 234.472,381.345 241.472,377.178 248.5,373C 251.393,371.851 254.393,371.351 257.5,371.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#fe8c00",
    d: "M 257.5,371.5 C 287.963,387.562 317.63,404.895 346.5,423.5C 346.062,423.435 345.728,423.601 345.5,424C 372.706,453.037 399.706,482.203 426.5,511.5C 425.833,511.5 425.167,511.5 424.5,511.5C 393.702,492.596 362.702,473.93 331.5,455.5C 331.611,454.883 331.944,454.383 332.5,454C 306.8,427.302 281.467,400.302 256.5,373C 257.056,372.617 257.389,372.117 257.5,371.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.972
    },
    fill: "#fe7f00",
    d: "M 227.5,385.5 C 235.16,394.493 243.16,403.16 251.5,411.5C 241.122,418.528 230.455,425.195 219.5,431.5C 212.231,422.226 204.564,413.226 196.5,404.5C 206.63,397.93 216.964,391.597 227.5,385.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.979
    },
    fill: "#fd6700",
    d: "M 97.5,431.5 C 97.1681,441.855 97.5014,452.188 98.5,462.5C 104.184,459.139 109.851,455.806 115.5,452.5C 124.265,460.925 132.265,469.925 139.5,479.5C 129.5,485.5 119.5,491.5 109.5,497.5C 93.3792,481.257 77.7125,464.59 62.5,447.5C 62.5,431.167 62.5,414.833 62.5,398.5C 63.1174,398.389 63.6174,398.056 64,397.5C 72.3333,406.5 80.6667,415.5 89,424.5C 91.4356,427.447 94.2689,429.78 97.5,431.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.976
    },
    fill: "#fd9900",
    d: "M 413.5,400.5 C 424.8,411.968 435.966,423.635 447,435.5C 447.191,433.292 447.691,431.292 448.5,429.5C 448.5,449.5 448.5,469.5 448.5,489.5C 437.567,477.396 426.4,465.396 415,453.5C 414.817,450.635 414.317,447.969 413.5,445.5C 413.5,430.5 413.5,415.5 413.5,400.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fd7900",
    d: "M 196.5,404.5 C 204.564,413.226 212.231,422.226 219.5,431.5C 210.5,436.833 201.5,442.167 192.5,447.5C 191.588,445.405 190.421,443.405 189,441.5C 181.927,434.931 175.427,427.931 169.5,420.5C 178.327,414.918 187.327,409.585 196.5,404.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.982
    },
    fill: "#fd7300",
    d: "M 169.5,420.5 C 175.427,427.931 181.927,434.931 189,441.5C 190.421,443.405 191.588,445.405 192.5,447.5C 184.133,453.017 175.466,458.017 166.5,462.5C 158.16,454.16 150.16,445.493 142.5,436.5C 151.327,430.918 160.327,425.585 169.5,420.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#fe9200",
    d: "M 346.5,423.5 C 368.466,436.445 390.466,449.445 412.5,462.5C 413.495,456.872 413.829,451.206 413.5,445.5C 414.317,447.969 414.817,450.635 415,453.5C 426.4,465.396 437.567,477.396 448.5,489.5C 449.577,499.346 445.911,506.679 437.5,511.5C 433.833,511.5 430.167,511.5 426.5,511.5C 399.706,482.203 372.706,453.037 345.5,424C 345.728,423.601 346.062,423.435 346.5,423.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.975
    },
    fill: "#fd6d00",
    d: "M 142.5,436.5 C 150.16,445.493 158.16,454.16 166.5,462.5C 157.705,468.403 148.705,474.069 139.5,479.5C 132.265,469.925 124.265,460.925 115.5,452.5C 124.335,446.915 133.335,441.581 142.5,436.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.978
    },
    fill: "#fd6000",
    d: "M 62.5,447.5 C 77.7125,464.59 93.3792,481.257 109.5,497.5C 101.432,502.195 93.4323,506.862 85.5,511.5C 81.5,511.5 77.5,511.5 73.5,511.5C 68.4635,508.956 64.9635,504.956 63,499.5C 62.5001,482.17 62.3334,464.837 62.5,447.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookmark);
export default __webpack_public_path__ + "static/media/bookmark.7b828f21e9adfc918ac1dce1efc97abf.svg";
export { ForwardRef as ReactComponent };